
export default {
    name: 'BaseDropdown',

    props: {
        buttonText: {
            type: String,
            default: null,
        },

        openOnHover: {
            type: Boolean,
            default: false,
        },

        forceOpen: {
            type: Boolean,
            default: false,
        },

        triggers: {
            type: [Array, null],
            default: null,
        },
        theme: {
            type: String,
            default() {
                return this.defaultTheme
            },
        },
    },
    computed: {
        defaultTheme() {
            return this.openOnHover ? 'menu' : 'dropdown'
        },
    },
    methods: {
        show() {
            this.$emit('apply-show')
        },
        hide() {
            this.$emit('apply-hide')
        },
    },
}
